import React from "react";

export default function PlanInvalid() {
    return (
        <div className="container py-5">
            <div className="row justify-content-center">
                <div className="col-md-8">
                    <div className="card text-center shadow-sm p-4">
                        <div className="card-body">
                            <img src="/assets/img/sessionExpired.png"alt="" className="img-fluid sessionExpiredImage"/>
                            <h4 className="text-danger mb-3 PlanexpiredText">Plan Unavailable</h4>
                            <p className="mb-0">
                                This plan is either <strong>expired</strong> or has already been <strong>paid</strong>.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
